import stickybits from 'stickybits'

stickybits('.is-sticky')
